var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPatientLogoWarning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 50,
  height: 50,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 50,
  height: 50,
  fill: "#FFF8DA",
  rx: 10
})), /*#__PURE__*/React.createElement("mask", {
  id: "PatientLogoWarning_svg__a",
  width: 26,
  height: 26,
  x: 12,
  y: 12,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M12 12h26v26H12z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#PatientLogoWarning_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFA000",
  d: "M25 30.417q.461 0 .772-.312.312-.31.312-.771t-.312-.772A1.05 1.05 0 0 0 25 28.25q-.46 0-.772.312a1.05 1.05 0 0 0-.311.772q0 .46.311.771.312.312.772.312m0-4.333q.461 0 .772-.312.312-.311.312-.772v-4.333q0-.46-.312-.772a1.05 1.05 0 0 0-.772-.311q-.46 0-.772.311a1.05 1.05 0 0 0-.311.772V25q0 .461.311.772.312.312.772.312m0 9.75q-2.247 0-4.225-.854a10.9 10.9 0 0 1-3.44-2.315 10.9 10.9 0 0 1-2.315-3.44A10.55 10.55 0 0 1 14.167 25q0-2.247.853-4.225a10.9 10.9 0 0 1 2.316-3.44 10.9 10.9 0 0 1 3.44-2.315A10.55 10.55 0 0 1 25 14.167q2.248 0 4.225.853a10.9 10.9 0 0 1 3.44 2.316 10.9 10.9 0 0 1 2.316 3.44q.852 1.976.853 4.224 0 2.248-.854 4.225a10.9 10.9 0 0 1-2.315 3.44 10.9 10.9 0 0 1-3.44 2.316 10.55 10.55 0 0 1-4.225.853m0-2.167q3.63 0 6.148-2.519 2.52-2.518 2.519-6.148t-2.519-6.148T25 16.334q-3.629 0-6.148 2.518-2.518 2.52-2.518 6.148 0 3.63 2.518 6.148 2.52 2.52 6.148 2.519"
}))));
export default SvgPatientLogoWarning;